import { useMemo } from 'react';
import { useStoreContext } from '../../../../components/Context';
import { useField } from '../hooks';
import { requirements, requirementValue } from '../paths';
import { getRequirementDeps } from './selectors';
export var useRequirements = function () {
    var state = useStoreContext()[0];
    var path = requirements(getRequirementDeps(state));
    var memoizedPath = useMemo(function () { return path; }, path);
    return useField(memoizedPath);
};
export var useRequirementValue = function (name) {
    var state = useStoreContext()[0];
    var path = requirementValue(getRequirementDeps(state), name);
    var memoizedPath = useMemo(function () { return path; }, path);
    return useField(memoizedPath);
};
